import { createFileRoute, redirect } from '@tanstack/react-router';

import { LandingPage } from '@/features/landing/pages/LandingPage';

export const Route = createFileRoute('/')({
  component: LandingPage,
  beforeLoad: () => {
    const token = localStorage.getItem('access_token');
    if (token) {
      throw redirect({ to: '/patients' });
    }
  },
});
